<template>
  <v-data-table
      :headers="headers"
      :items="trl"
      :items-per-page="10"
      :search="search"
      item-key="id"
      dense
      class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-text-field
            v-model="search"
            label="Search"
            class="mx-4"
        ></v-text-field>
      <v-btn
          color="primary"
          dark
          class="mb-2"
          @click="newTrial"
          v-show="mayCreate"
      >Add New Trial
      </v-btn>

      </v-toolbar>
    </template>
    <template v-slot:item.trialName="{ item }">
      {{ item.trialName }}
    </template>
    <template v-slot:item.register="{ item }">
      <v-btn x-small rounded color="red" dark v-show="isInActive(item)">Inactive</v-btn>
      <v-btn x-small rounded color="blue" dark @click="register(item)" v-show="isOpen(item)">Compete</v-btn>
      <v-btn x-small rounded color="green" dark @click="volunteer(item)" v-show="isSoon(item)">Volunteer</v-btn>
    </template>
    <template v-slot:item.entries="{ item }">
      {{ item.entries.length }} {{' / '}} {{ item.maxRuns }}
    </template>
    <template v-slot:item.type="{ item }">
      {{ item.type }}
    </template>
    <template v-slot:item.startDate="{ item }">
      {{ $iso2AU(item.startDate) }}
    </template>
    <template v-slot:item.host="{ item }">
      {{ item.host.clubName}}
    </template>
    <template v-slot:item.city="{ item }">
      {{ item.city }}
    </template>
    <template v-slot:item.state="{ item }">
      {{ item.state }}
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
          small
          class="mr-2"
          @click="trialClicked(item)"
      >
        mdi-file-document-outline
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
//import Menu from '@/components/Menu.vue'

export default {
  name: "TrialTbl",
  components: {},
  props: {
    trl: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    newTrial: async function () {
      let theToken = localStorage.getItem('token')
      if (theToken == null) {
        // alert('You must log in to access this feature')
        this.$router.push('/')
      }
      try {
        let response = await this.$http.post(this.$remote + '/api.host/getclub', {token: theToken})
        this.$usrStore.token = response.data.token
        let club = response.data.club
        if (club == null) {
          alert(response.data.msg)
          return
        }
        if(!confirm(`This will create a new ORT or Trial for ${club.clubName}\nDo you want to proceed?`)) {
          return
        }
        response = await this.$http.post(this.$remote + '/api.trial/newtrial', {token: theToken})
        this.$usrStore.token = response.data.token
        const newTrial = response.data.trial
        console.log(newTrial)
        this.$emit('reloadTrials')
        this.$emit('showTrial', newTrial)
      } catch (e) {
        alert(e)
      }
    },
    trialClicked(item) {
      //alert(item.trialName)
      this.$emit("showTrial", item)
    },
    register(item) {
      this.$emit("showTrialReg", item)
    },
    volunteer(item) {
      this.$emit("showVolReg", item)
    },
    isInActive(item) {
      return !item.active
    },
    isOpen(item) {
      return (item.status == 'open') && item.active
    },
    isSoon(item) {
      let now = new Date().toISOString().substr(0,10)
      return (item.startDate >= now)  && item.active
    }

  },
  computed: {
    mayCreate() {
      return this.$hasRole(['Host'])
    },
  },
  data: () => ({
    search: '',
    headers: [
      {
        text: 'Name',
        align: 'start',
        sortable: true,
        value: 'trialName'
      },
      {text: 'Register', value: 'register'},
      {text: 'Entries', value: 'entries'},
      {text: 'Type', value: 'type'},
      {text: 'Trial Date', value: 'startDate'},
      {text: 'Host', value: 'host'},
      {text: 'City', value: 'city'},
      {text: 'State', value: 'state'},
      {text: 'Details', value: 'actions', sortable: false},
    ]
  })
}

</script>

<style scoped>

</style>